import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
// Context
import { ThemeProvider } from './context/ThemeContext';
import { MasterDataProvider } from './context/MasterDataContext';
import { ProjectProvider } from './context/ProjectContext';
import { CrewProvider } from './context/CrewContext';
import { EquipmentProvider } from './context/EquipmentContext';
import { AuthProvider } from './context/AuthContext'

// Layouts
import PrivateLayout from './layouts/PrivateLayout';
import PublicLayout from './layouts/PublicLayout';

// Protection Wrapper
import ProtectedRoute from './components/ProtectedRoute';
import DashboardPage from './pages/DashboardPage';
import RequirementsPage from './pages/RequirementsPage';
import EquipmentPage from './pages/EquipmentPage';

import CrewManagementPage from 'pages/CrewManagementPage';
import AddCrewMemberPage from 'pages/AddCrewMemberPage';
import AddTaskPage from 'pages/AddTaskPage';
import ViewTaskPage from 'pages/ViewTaskPage';
import AiMatchmakerPage from 'pages/AiMatchmakerPage';
import SelectEquipmentPage from 'pages/SelectEquipmentPage';
import ProjectBriefPage from 'pages/ProjectBriefPage';
import ProjectDetailPage from 'pages/ProjectDetailPage';
import LandingPage from 'pages/LandingPage';
import LandingPageChoice from 'pages/LandingPageChoice';
import LoginPage from 'pages/LoginPage';
import SignupPage from 'pages/SignupPage';
import RequirementHomePage from 'pages/RequirmentHomePage';
import LoginPageCrew from 'pages/LoginPageCrew';
import ForgotPasswordPageCrew from 'pages/forgotpassword';
import ResetPasswordPageCrew from 'pages/resetpassword';
import SignupPageCrew from 'pages/SignUpCrew';
import CpSignupPage from 'pages/CPSignupPage';
import SignupPageN from 'pages/signupnew';
import AvailabilityPage from 'pages/CrewAvailabilityPage';
import CreatorDashboard from 'pages/CreatorDashboard';
import RequestsShootsPage from 'pages/RequestsShootsPage';
import CreatorEquipments from 'pages/CreatorEquipments';
import CreativeProfilePage from 'pages/CreativeProfilePage';
import EquipmentRentPage from 'pages/equipmentRentPage';
import LivestreamPage from 'pages/LivestreamPage';
import ManageLivestreamPage from 'pages/ManageLivestreamPage';
import RentReuestEquipmentPage from 'pages/equipmentRentRequests';

const App = () => {
  return (
    <ThemeProvider>
      <MasterDataProvider>
        <ProjectProvider>
          <CrewProvider>
            <EquipmentProvider>
              <AuthProvider>
                <BrowserRouter>
                  <Routes>
                    {/* === 1. PUBLIC Routes (Uses PublicLayout) === */}
                    <Route element={<PublicLayout />}>
                      <Route path="/" element={<LandingPage />} />
                      <Route path="/applanding" element={<LandingPageChoice />} />
                      <Route path="/login" element={<LoginPage />} />
                      <Route path="/signup-admin" element={<SignupPage />} />
                      <Route path="/login" element={<LoginPageCrew />} />
                      <Route path="/forgot-password" element={<ForgotPasswordPageCrew />} />
                      <Route path="/reset-password" element={<ResetPasswordPageCrew />} />
                      <Route path="/signUpCrew" element={<SignupPageCrew />} />
                      <Route path="/creative-profile/signup" element={<CpSignupPage />} />
                      <Route path="/signup" element={<SignupPageN />} />
                    </Route>

                    {/* === 2. PRIVATE Routes (Uses ProtectedRoute and PrivateLayout) === */}
                    <Route element={<ProtectedRoute />}>
                      <Route element={<PrivateLayout />}>
                        <Route path="/dashboard" element={<DashboardPage />} />
                        <Route path="/project/:id" element={<ProjectDetailPage />} />
                        <Route path="/requirements/:id?" element={<RequirementsPage />} />
                        <Route path="/equipment" element={<EquipmentPage />} />
                        <Route path="/rent-equipment-request" element={<RentReuestEquipmentPage />} />
                        <Route path="/requirements/ai-matchmaker" element={<AiMatchmakerPage />} />
                        <Route path="/requirements/ai-matchmaker/select-equipment" element={<SelectEquipmentPage />} />
                        <Route path="/requirements/ai-matchmaker/select-equipment/project-brief" element={<ProjectBriefPage />} />
                        <Route path="/crew-management" element={<CrewManagementPage />} />
                        <Route path="/crew-management/add-member" element={<AddCrewMemberPage />} />
                        <Route path="/crew-management/assign-task" element={<AddTaskPage />} />
                        <Route path="/crew-management/view-task" element={<ViewTaskPage />} />
                        <Route path="/book-a-shoot" element={<RequirementHomePage />} />
                        <Route path="/crew-availability" element={<AvailabilityPage />} />
                        <Route path="/creator-dashboard" element={<CreatorDashboard />} />
                        <Route path="/equipment-crew" element={<CreatorEquipments />} />
                        <Route path="/requests-and-shoots" element={<RequestsShootsPage />} />
                        <Route path="/profile" element={<CreativeProfilePage />} />
                        <Route path="/equipment-rent" element={<EquipmentRentPage />} />
                        <Route path="/livestream" element={<LivestreamPage />} />
                        <Route path="/livestream/:projectId" element={<ManageLivestreamPage />} />
                      </Route>
                    </Route>

                    {/* === 3. Fallback Route === */}
                    {/* <Route path="*" element={<NotFoundPage />} /> */}
                  </Routes>
                </BrowserRouter>
                <Toaster position="bottom-right" />
              </AuthProvider>
            </EquipmentProvider>
          </CrewProvider>
        </ProjectProvider>
      </MasterDataProvider>
    </ThemeProvider>
  );
};

export default App;
